<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create User" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-user-form [user]="user" [isEditing]="false" *ngIf="user"></app-user-form>
        </form>
      </div>
    </section>
  </div>
</div>


